module.exports = __webpack_public_path__ + "assets/images/P-grey-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/P-grey-icon.png
// module id = 138
// module chunks = 1